import { render, staticRenderFns } from "./FollowerRequests.vue?vue&type=template&id=369bb150&scoped=true"
import script from "./FollowerRequests.vue?vue&type=script&lang=js"
export * from "./FollowerRequests.vue?vue&type=script&lang=js"
import style0 from "./FollowerRequests.vue?vue&type=style&index=0&id=369bb150&prod&lang=scss&scoped=true"
import style1 from "./FollowerRequests.vue?vue&type=style&index=1&id=369bb150&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "369bb150",
  null
  
)

export default component.exports